import React, { createContext, PropsWithChildren, useContext } from "react";

import { UseFiltersTabReturn } from "./hooks/use_filters_tab";
import { UseOrderTabReturn } from "./hooks/use_order_tab";

type FiltersAndOrderConfigContextData = {
  order: UseOrderTabReturn;
  filters: UseFiltersTabReturn;
};

const FiltersAndOrderConfigContext = createContext<FiltersAndOrderConfigContextData | null>(null);

export const FiltersAndOrderConfigContextProvider = ({
  children,
  order,
  filters
}: PropsWithChildren<FiltersAndOrderConfigContextData>): JSX.Element => (
  <FiltersAndOrderConfigContext.Provider
    value={{
      filters,
      order
    }}
  >
    {children}
  </FiltersAndOrderConfigContext.Provider>
);

export const useFiltersAndOrderConfigContext = () => {
  const context = useContext(FiltersAndOrderConfigContext);

  if (!context) {
    throw new Error("useFiltersConfigContext must be used within a FiltersConfigContextProvider");
  }

  return context;
};
